const UpdateOverview = () =>
  import(
    /* webpackChunkName: "UpdateOverview" */ '../views/updates/UpdateOverview.vue'
    );

export const routeDigitalContent = [
  {
    path: 'updates',
    name: 'UpdateOverview',
    component: UpdateOverview,
    meta: {
      title: 'Update overview'
    }
  }
];
